export const excelDownload = (headers, rows, row, name) => {
  const body = [];
  const wrap = (tag, html, attr) => `<${tag}${attr ? ` ${attr?.join?.(' ')}` : ''}>${html}</${tag}>`;
  body.push(wrap('tr', headers?.map?.(c => wrap('th', c))?.join?.('')));
  rows?.forEach?.((r, i) => body.push(wrap('tr', row?.(r, i)?.map?.(c => wrap('td', c))?.join?.(''))));
  const link = document.createElement('a');
  const data = `data:application/vnd.ms-excel;base64,${btoa( wrap('table', body.join(''), ['border="1"']))}`;
  link.setAttribute('href', data);
  const datetime = new Date().toISOString().replace(/[-T:.Z]/g, '');
  link.setAttribute('download', `${name}-${datetime}.xls`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
